let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("h3oYl")).then(() => parcelRequire('e4emr'));